import type { FormaRent } from '../core/FormaRent';
import type { OpenParams } from '../types';

function paramsFrom(el: HTMLElement): OpenParams {
  const p: OpenParams = {};
  const product = el.getAttribute('data-forma-product');
  const option = el.getAttribute('data-forma-option');
  const category = el.getAttribute('data-forma-category');
  if (product) p.product = product;
  if (option) p.option = option;
  if (category) p.category = category;
  return p;
}

export function installDataButtons(instance: FormaRent): () => void {
  const clickHandler = (e: MouseEvent): void => {
    const el = e.target as HTMLElement | null;
    const trigger = el?.closest?.('[data-forma-open]');
    if (!(trigger instanceof HTMLElement)) return;
    e.preventDefault();
    instance.open(paramsFrom(trigger));
  };
  document.addEventListener('click', clickHandler);
  return (): void => {
    document.removeEventListener('click', clickHandler);
  };
}
